<template>
  
  <div class="notify" v-if="visible">
    <transition-group name="fade">
      <GlobalNotifyMessage v-for="message in getMessages" :key="message.id"
        :message="message"
        @closeMessage="closeNotify(message)"
      />
    </transition-group>
    
  </div>
</template>

<script>
  import GlobalNotifyMessage from '@/components/shares/GlobalNotifyMessage'

  export default {
    components: { GlobalNotifyMessage },
    computed: {
      getMessages() {
        const messages = this.notifications
        return messages.sort((a, b) => (a.id < b.id) ? 1 : (b.id < a.id) ? -1 : 0)
      },
      notifications() {
        return this.$notify.notifications()
      },
      visible() {
        return this.notifications.length > 0
      }
    },
    data() {
      return {
        messageId: 0
      }
    },
    methods: {
      closeNotify(message){
        const index = this.notifications.findIndex(e => e.id === message.id)
        if (index > -1) this.notifications.splice(index, 1)
      }
    },
    name: 'GlobalNotify'
  }
</script>

<style scoped>
  .notify {
    position: fixed;
    width: 15%;
    min-height: 40px;
    top: 13%;
    right: 1%;
    color: black;
    z-index: 2000;
  }

  @media screen and (max-width: 1800px) {
    .notify{
      width: 28%;
    }
  }

  @media screen and (max-width: 1200px) {
    .notify{
      width: 35%;
    }
  }

  @media screen and (max-width: 800px) {
    .notify{
      width: 45%;
    }
  }

  @media screen and (max-width: 800px) {
    .notify{
      width: 99%;
      left: 0%;
      right: 0%;
      margin-left: 10px;
      margin-right: 10px;
    }
  }

  @media screen and (max-width: 600px) {
    .notify{
      width: 85%;
      left: 10%;
      right: 10%;
      margin-left: 10px;
      margin-right: 10px;
    }
  }

  .fade-leave-active,
  .fade-enter-active {
    transition: .5s;
  }

  .fade-leave-to {
    top: 50%;
    opacity: 0;
  }
  .fade-enter  {
    top: -10%;
    opacity: 0;
  }
</style>
